import { ChartsDataState, defaultChartsDataState } from "./state";
import { combineReducersPartial } from "../../reducer-factory";
import {
    getOverallFunnelPerformanceDataRequest,
    getDateDataRequest,
    getEnvironmentDataRequest,
    getWeekdayDataRequest,
    getAgeGroupDataRequest,
    getGenderDataRequest,
    getOSDataRequest,
    getRegionDataRequest,
    getAdFormatsDataRequest,
    getAdFormatAdTemplateDataRequest,
    getAdInteractionDataRequest
} from "@api/common";

export const chartDataReducer = combineReducersPartial<ChartsDataState>(
    {
        overallData: getOverallFunnelPerformanceDataRequest.reducer,
        dateData: getDateDataRequest.reducer,
        environmentData: getEnvironmentDataRequest.reducer,
        weekdayData: getWeekdayDataRequest.reducer,
        ageGroupData: getAgeGroupDataRequest.reducer,
        genderData: getGenderDataRequest.reducer,
        osData: getOSDataRequest.reducer,
        regionData: getRegionDataRequest.reducer,
        adFormatData: getAdFormatsDataRequest.reducer,
        adFormatAdTemplateData: getAdFormatAdTemplateDataRequest.reducer,
        adInteractionData: getAdInteractionDataRequest.reducer
    },
    defaultChartsDataState
);
